import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const HeaderWidgetContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  margin-bottom: 0;
  flex-wrap: nowrap;
  width: 100%;
`;

export const HeaderTitleH1 = styled.h1<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  line-height: ${({ theme: { token } }) => token.lineHeightHeading1};
  margin: 0;
  text-align: left;
  display: inline;
  flex-shrink: 0;
`;

export const HeaderTitleH2 = styled.h2<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading2}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  line-height: ${({ theme: { token } }) => token.lineHeightHeading2};
  margin: 0;
  text-align: left;
  display: inline;
  flex-shrink: 0;
`;

export const HeaderTitleH3 = styled.h3<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  line-height: ${({ theme: { token } }) => token.lineHeightHeading3};
  margin: 0;
  text-align: left;
  display: inline;
  flex-shrink: 0;
`;

export const HeaderTitleH4 = styled.h4<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
  line-height: ${({ theme: { token } }) => token.lineHeightHeading4};
  margin: 0;
  text-align: left;
  display: inline;
  flex-shrink: 0;
`;

export const HeaderSuffixBadge = styled.span<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  background: ${({ theme: { token } }) => token.colorPrimary};
  border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
  font-size: 10px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorTextLightSolid};
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

export const HeaderSuffixIconContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
`;

export const HeaderSuffixIconText = styled.span<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  color: ${({ theme: { token } }) => token.colorText};
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXXS}px;

  .tm-text {
    font-size: 8px;
    vertical-align: super;
  }
`;

export const LinkButtonsWidgetContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  margin-top: 0;
  flex-wrap: wrap;
  width: 100%;
`;

export const LinkButton = styled.a<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorPrimary};
  text-decoration: underline;
  text-underline-offset: 2px;
  text-decoration-skip-ink: none;
  font-size: ${({ theme: { token } }) => token.fontSizeLG || token.fontSize * 1.15}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  cursor: pointer;
  transition: color 0.2s ease;
  display: inline;
  text-align: left;

  &:hover {
    color: ${({ theme: { token } }) => token.colorPrimaryHover};
  }

  &:active {
    color: ${({ theme: { token } }) => token.colorPrimaryActive || token.colorPrimaryHover};
  }

  &::after {
    content: ' →';
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-skip-ink: none;
  }
`;

export const DynamicAIResponseContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.lineHeight}px;
  align-items: flex-start;
  width: 100%;
  max-width: 90%;
`;

export const TextWidgetContainer = styled.div<{ theme: { token: GlobalToken } }>`
  margin-bottom: 0;
  color: ${({ theme: { token } }) => token.colorText};
`;

export const TypingCursor = styled.span<{ theme: { token: GlobalToken } }>`
  display: inline-block;
  width: 8px;
  background: ${({ theme: { token } }) => token.colorPrimary};
  animation: blink 1s steps(1) infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

export const StreamingIndicator = styled.div<{ theme: { token: GlobalToken } }>`
  display: inline-flex;
  align-items: center;
  color: ${({ theme: { token } }) => token.colorTextTertiary};
  font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  margin-top: ${({ theme: { token } }) => token.marginXS}px;
  animation: pulse 1.5s ease-in-out infinite;

  span {
    letter-spacing: 2px;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.4;
    }
    50% {
      opacity: 0.8;
    }
  }
`;

export const SpaceLineContainer = styled.div<{ lines: number; theme: { token: GlobalToken } }>`
  height: ${({ lines, theme: { token } }) => lines * token.lineHeight}px;
  min-height: ${({ lines, theme: { token } }) => lines * token.lineHeight}px;
`;
